export default __webpack_public_path__ + "static/media/Delete 8.dc394e06.svg";